export default __webpack_public_path__ + "static/media/4.e7821e88.png";